interface MobileBackdropProps {
  onClose: () => void
}

export default function MobileBackdrop({ onClose }: MobileBackdropProps) {
  return (
    <button
      type="button"
      aria-label="Close chat"
      onClick={onClose}
      className="fixed inset-0 z-30 bg-black/30 xl:hidden"
    />
  )
}
